export default __webpack_public_path__ + "static/media/mufg.13dbf3a1.svg";